<p *ngIf="fndColumns" [style.color]="fndColumns.columTextColor||'#000'" class="valueFoarmates">{{ this.valueFormatted || '' }}</p>
<!-- <div *ngIf="fndColumns" style="text-wrap: wrap;line-height: 16px;padding: 5px 0;">
</div> -->